/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiDefOrganizationData } from '../../models/api-def-organization-data';
import { ApiDefProjectData } from '../../models/api-def-project-data';

export interface OrganizationsCreateProject$Params {

/**
 * The ID of the organization to create the project in
 */
  organizationId: string;
      body: ApiDefProjectData
}

export function organizationsCreateProject(http: HttpClient, rootUrl: string, params: OrganizationsCreateProject$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'project'?: ApiDefProjectData;
'organization'?: ApiDefOrganizationData;
}>> {
  const rb = new RequestBuilder(rootUrl, organizationsCreateProject.PATH, 'post');
  if (params) {
    rb.path('organizationId', params.organizationId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<{
      'project'?: ApiDefProjectData;
      'organization'?: ApiDefOrganizationData;
      }>;
    })
  );
}

organizationsCreateProject.PATH = '/organizations/{organizationId}/projects';
